import { TestLevel } from "src/app/models/dto/testLevel";
import { GraphQLTestLevelOutput } from "../models/output/graphql-test-level-output";

export function convertGraphqlTestLevelToTestLevel(input: GraphQLTestLevelOutput): TestLevel {
    return {
      id: input.Id,
      name: input.Name
    }
  }